import React, { useState, useEffect } from "react";
import DropDownMenu from "../components/DropDownMenu";
import {
  saveAsMappings,
  getInputColumnsData,
  getOutputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import { useSelector, useDispatch } from "react-redux";
import InputField from "../components/InputField";
import Button from "../components/Button";
import { Alert } from "antd";
import { showAddedRulesToast } from "../helpers";

const initialObject = {
  inputColumn: "",
  outputColumn: "",
  formula: [],
  roundTo: 0,
  appliedRule: 7,
};

const FormulaPage = () => {
  const dispatch = useDispatch();
  const [formulaObject, setobject] = useState(initialObject);
  const [operation, setOperation] = useState("");
  const [userDefinedData, setUserDefinedData] = useState("");
  const [formulas, setFormulas] = useState([]);
  const [decimalPlaces, setDecimalPlaces] = useState(0);
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);
  const [showAlert, setShowAlert] = useState(false);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag);

  useEffect(() => {
    if (state?.type === "formula") {
      setobject((prev) => ({ ...prev, ...state.data }));
      setFormulas((prev) => [...prev, ...state.data.formula]);
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const operations = [
    { label: "Multiply", value: "*" },
    { label: "Divide", value: "/" },
    { label: "Add", value: "+" },
    { label: "Subtract", value: "-" },
  ];

  const decimalOptions = [
    { label: "0", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
  ];

  const decodeOperation = {
    "*": "Multiply",
    "/": "Divide",
    "+": "Add",
    "-": "Subtract",
  };

  const handleOnChange = (e) => {
    setobject((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    const newFormula = {
      operation: operation,
      value: parseFloat(userDefinedData),
      output: null,
    };
    setFormulas((prev) => [...prev, newFormula]);
    setUserDefinedData("");
    setOperation("");
  };

  const createRule = () => {
    if (
      formulas.length === 0 ||
      formulaObject.inputColumn === "" ||
      formulaObject.outputColumn === ""
    ) {
      setShowAlert(true);
    } else {
      dispatch(
        saveAsMappings({
          ...formulaObject,
          formula: formulas,
          roundTo: decimalPlaces,
        })
      );
      showAddedRulesToast(
        formulaObject.appliedRule,
        isInLocalEditMode ? "Updated" : "added"
      ); // Show toast notification
      reset();
    }
  };

  const reset = () => {
    setobject(initialObject);
    setFormulas([]);
    setDecimalPlaces(0);
    setIsInLocalEditMode(false);
  };

  return (
    <>
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 p-2">
        <DropDownMenu
          label={"Select Input Column"}
          name="inputColumn"
          value={formulaObject.inputColumn}
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          onChange={handleOnChange}
        />
        <DropDownMenu
          label={"Select Output Column"}
          name="outputColumn"
          value={formulaObject.outputColumn}
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          onChange={handleOnChange}
        />
        {/* Select an operation to be performed */}
        <DropDownMenu
          label={"Select Operation"}
          name="operation"
          value={operation}
          options={operations.map((item) => ({
            label: item.label,
            value: item.value,
          }))}
          onChange={(e) => {
            setOperation(e.target.value);
          }}
        />
        <InputField
          label={"Value"}
          name={"userDefinedData"}
          type="number"
          value={userDefinedData}
          placeholder={""}
          onChange={(e) => setUserDefinedData(e.target.value)}
        />

        <div className="h-40 bg-gray-100 overflow-auto rounded p-2">
          <span className="font-bold">Formulas</span>
          {formulas?.map((formula, index) => (
            <div
              className="flex  justify-between bg-gray-300 rounded mb-1 p-1"
              key={index}
            >
              <span>Input </span>
              <span>{decodeOperation[formula.operation]}</span>
              <span>{formula.value}</span>
            </div>
          ))}
        </div>

        <div className="col-span-2 flex justify-between gap-4">
          <Button
            disabled={userDefinedData === "" || operation === ""} // disable button if userDefinedData or operation is empty
            btnText={"Create Iterations"}
            handleOnClick={handleAddNewRule}
          />

          <Button
            // disabled={formulas.length === 0}
            btnText={"reset"}
            btnType="cancel"
            handleOnClick={reset}
          />
        </div>
        <DropDownMenu
          label={"Output Rounded to Decimal Places"}
          name="decimalPlaces"
          value={decimalPlaces}
          options={decimalOptions}
          onChange={(e) => setDecimalPlaces(parseInt(e.target.value))}
        />
        {/* Create Rule */}
        <div className="col-span-2 flex justify-between gap-4">
          <Button
            btnText={`${isInLocalEditMode ? "Update" : "Save Rule"}`}
            handleOnClick={createRule}
          />
        </div>
      </div>
      {showAlert && (
        <Alert
          message="Please fill in all fields before creating iterations."
          type="error"
          closable
          onClose={() => setShowAlert(false)}
        />
      )}
    </>
  );
};

export default FormulaPage;
